function initFaqAccordion() {
  const faqBlocks = Array.from(document.querySelectorAll('.faq-block'));

  faqBlocks.forEach((faqBlock) => {
    const items = Array.from(faqBlock.querySelectorAll('.faq-item'));

    items.forEach((item) => {
      const trigger = item.querySelector('.question');
      const answer = item.querySelector('.answer');

      if (!trigger || !answer) {
        return;
      }

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        items.forEach((otherItem) => {
          const otherTrigger = otherItem.querySelector('.question');
          const otherAnswer = otherItem.querySelector('.answer');

          if (!otherTrigger || !otherAnswer) {
            return;
          }

          otherItem.classList.remove('is-open');
          otherTrigger.setAttribute('aria-expanded', 'false');
          otherAnswer.setAttribute('hidden', 'hidden');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          answer.removeAttribute('hidden');
        }
      });
    });
  });
}

initFaqAccordion();
